// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__19qg6","modalTitleContainer":"Modal_modalTitleContainer__QsPB_","cardContainer":"Modal_cardContainer__3vhJu"};